(() => {
const $25042d348ba60624$export$e1252723db1c541 = {
    popupContainer: '.popup-container',
    popup: '.popup',
    popupClose: '.popup__close',
    popupCtr: '.popup__content',
    popupVideos: '.popup iframe',
    youTubeContainer: '.youtube',
    selfHostedVideo: 'video'
};
const $25042d348ba60624$export$188d75d71883854a = {
    visibleClass: 'visible',
    popupOpen: 'popup-open'
};


const $ab068c756af26091$export$348d584e223bdf1b = async (ref)=>{
    // Show the popup with the given ID
    const popup = document.querySelector(`${(0, $25042d348ba60624$export$e1252723db1c541).popupContainer}[data-popup-ref="${ref}"]`);
    if (!popup) {
        console.error(`Error showing popup "${ref}": Popup with that reference not found.`);
        return;
    }
    popup.hidden = false;
    // Show the popup container and add the visible class
    document.querySelector(`${(0, $25042d348ba60624$export$e1252723db1c541).popupContainer}[data-popup-ref="${ref}"]`).classList.toggle((0, $25042d348ba60624$export$188d75d71883854a).visibleClass, true);
    document.querySelector('body').classList.add((0, $25042d348ba60624$export$188d75d71883854a).popupOpen);
};
const $ab068c756af26091$export$bba5038aab73375b = ()=>{
    document.querySelector('body').classList.remove((0, $25042d348ba60624$export$188d75d71883854a).popupOpen);
    document.querySelectorAll((0, $25042d348ba60624$export$e1252723db1c541).popupContainer).forEach((popup)=>{
        popup.classList.remove((0, $25042d348ba60624$export$188d75d71883854a).visibleClass);
        popup.hidden = true;
    });
    // Stop YouTube videos
    document.querySelectorAll(`${(0, $25042d348ba60624$export$e1252723db1c541).popupVideos}, ${(0, $25042d348ba60624$export$e1252723db1c541).selfHostedVideo}`).forEach((video)=>{
        // check if video is playing
        let src = video.getAttribute('src');
        if (!src) return;
        src = src.replace('autoplay=1', 'autoplay=0');
        src = src.replace('mute=1', 'mute=0');
        video.setAttribute('src', src);
    });
};



/**
 * Add event listeners
 */ document.querySelectorAll((0, $25042d348ba60624$export$e1252723db1c541).popupContainer).forEach((popup)=>{
    const ref = popup.getAttribute('data-popup-ref');
    document.querySelectorAll(`[data-open-popup="${ref}"]`).forEach((trigger)=>{
        trigger.addEventListener('click', (e)=>{
            e.preventDefault();
            (0, $ab068c756af26091$export$348d584e223bdf1b)(ref);
            // Stop propagation to prevent window click listener to trigger
            e.stopPropagation();
        });
    });
    // Video handling
    popup.addEventListener('click', (e)=>{
        // Stop propagation if popup does not contain any video
        // (propagation will be stopped later to enable later click events)
        if (!popup.querySelector((0, $25042d348ba60624$export$e1252723db1c541).youTubeContainer)) e.stopPropagation();
    });
});
document.querySelectorAll((0, $25042d348ba60624$export$e1252723db1c541).popupClose).forEach((close)=>{
    close.addEventListener('click', (0, $ab068c756af26091$export$bba5038aab73375b));
});
window.addEventListener('keydown', (event)=>{
    if (event.key === 'Escape') (0, $ab068c756af26091$export$bba5038aab73375b)();
});
window.addEventListener('showPopup', (event)=>{
    (0, $ab068c756af26091$export$348d584e223bdf1b)(event.detail);
});
// hide popup on click outside
window.addEventListener('click', (event)=>{
    const popup = document.querySelector((0, $25042d348ba60624$export$e1252723db1c541).popupContainer);
    const target = event.target;
    const isInPopup = popup && popup.contains(target);
    const isDatepicker = target.closest('.ui-datepicker'); // Datepicker
    const isYoutube = target.classList.contains('youtube'); // Youtube Video
    const isBorlabs = target.classList.contains('brlbs-cmpnt-cb-btn'); // Borlabs Cookie Button
    if (isInPopup || isDatepicker || isYoutube || isBorlabs) return;
    (0, $ab068c756af26091$export$bba5038aab73375b)();
});

})();
//# sourceMappingURL=popup.min.js.map
